let buttonMenu = document.querySelector(".header__mobile-nav-toggle");
let desktopMenu = document.querySelector("#mobile-menu_ctm");

let active_tab = $(".menu_button");

active_tab.click(function () {
  let getElement = $(".mobile-menu__panel_1");
  let getNextElement = $(".mobile-menu__panel_childs");
  let getMetaobject = $(".mobile-menu__panel_childs-metaobject");
  getMetaobject.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
  getNextElement.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
  getElement.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
  var tab = $(this).parent();
  var tab_attr = tab.attr("tab-id");
  var mobile_data = $(".mobile-tab");
  mobile_data.each(function (attr) {
    var check = $(this).attr("data-tab-id");
    $(this).removeClass("active");
    if (check == tab_attr) {
      $(this).addClass("active");
    }
  });
});

buttonMenu.addEventListener("click", function (e) {
  e.preventDefault();
  if (e.currentTarget.getAttribute("aria-expanded") === "false") {
    e.currentTarget.setAttribute("aria-expanded", true);
    desktopMenu.setAttribute("aria-hidden", false);
  } else {
    e.currentTarget.setAttribute("aria-expanded", false);
    desktopMenu.setAttribute("aria-hidden", true);
    if ($(".mobile-menu__panel").hasClass("is-open")) {
      $(".mobile-menu__panel").removeClass("is-open");
    }
  }
});

$(".button_link").click(function (e) {
  e.preventDefault();

  let $this = $(this);
  let parent = $this.parent(); // Get the parent element

  $this.each(function () {
    if ($(this).attr("aria-expanded") === "true") {
      $(this).attr("aria-expanded", "false");
    }
  });
  $this.attr("aria-expanded", "true");
  let closest = $this.closest(".mobile-menu__inner__ctm").siblings();
  let getElement = closest.closest(".mobile-menu__panel_1");
  let getNextElement = closest.closest(".mobile-menu__panel_childs");
  let getMetaobject = closest.closest(".mobile-menu__panel_childs-metaobject");
  getMetaobject.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
  getNextElement.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
  getElement.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
});

$(".button_link_child").click(function (e) {
  e.preventDefault();

  let $this = $(this);

  $this.each(function () {
    if ($(this).attr("aria-expanded") === "true") {
      $(this).attr("aria-expanded", "false");
    }
  });

  $this.attr("aria-expanded", "true");

  let parent = $this.parent().closest(".mobile-menu__panel_1");
  let getElement = parent.siblings(".mobile-menu__panel_childs");
  getElement.each(function () {
    $(this).removeClass("is-open");
    if ($(this).hasClass("is-open")) {
      $(this).addClass("is-open");
    }
  });
  let getMetaobject = parent.siblings(".mobile-menu__panel_childs-metaobject");
  getMetaobject.each(function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
    }
  });
});

$(".button_link_grand_child").click(function (event) {
  event.preventDefault();
  let $this = $(this);
  let title = $this.attr("data-title");
  let parent = $this.parent().closest(".mobile-menu__panel_childs");
  let parentAttr = $(parent).attr("data-type");
  let getElement = parent.siblings(".mobile-menu__panel_childs-metaobject");
  getElement.each(function () {
    let attribute = $(this).attr("data-type");
    $(this).removeClass("is-open");
    if (attribute == title) {
      $(this).addClass("is-open");
    }
  });
});

const mediaQuery = window.matchMedia("(min-width: 990px)");

if (mediaQuery.matches) {
  $(".mobile-menu__section_button button").click(function () {
    let $this = $(this);
    let parent = $this.parent().parent().siblings();
    $(parent).each(function () {
      if ($(this).hasClass("is-open")) {
        $(this).removeClass("is-open");
        // alert("bacck");
      }
    });
  });
  console.log("Viewport is 600px or less");
}
